import { useHistory, useLocation } from 'react-router-dom';

/**
 * Custom hook to update URL parameters based on the provided params object.
 * @param {Object} params - The parameters to set in the URL.
 */
export default () => {
  const history = useHistory();
  const location = useLocation();

  return {
    setUrlParams: (params) => {
      const urlParams = new URLSearchParams(location.search);

      Object.keys(params).forEach((key) => {
        if (params[key] === "" || params[key] === undefined) {
          urlParams.delete(key);
        } else {
          urlParams.set(key, params[key]);
        }
      });

      history.replace({
        pathname: location.pathname,
        search: urlParams.toString(),
      });
    },

    getUrlParams: () => {
      const urlParams = new URLSearchParams(location.search);
      const params = {};
      urlParams.forEach((value, key) => {
        params[key] = value;
      });

      return params;
    }
  };
}